'use strict'

/**
 * @type {Function}
 * @returns {Boolean}
 * @description Default function for the isDemo handler
 */
const defaultIsDemo = () => false

/**
 * @type {Function}
 * @returns {Boolean}
 * @description Simple variable to hold the reference to the isDemo
 * handler
 */
let handler = defaultIsDemo

/**
 * @type {Function}
 * @param {Function} fn
 * @description Sets the handler for checking if the demo mode is enabled
 */
export function setHandler(fn) {
  if (typeof fn !== 'function') {
    fn = defaultIsDemo
  }
  handler = fn
}

/**
 * @type {Function}
 * @returns {Boolean}
 * @description Checks if the demo mode is enabled
 */
export function isDemo() {
  return handler()
}
